<template>
    <div id="app">
        <div class="mai-wrapper" v-if="isLoggedIn">
            <theme-header></theme-header>
            <div class="main-content container">
                <message-boxes></message-boxes>
                <router-view></router-view>
            </div>
            <theme-footer></theme-footer>
        </div>
        <login-page v-else></login-page>

        <!-- Dialogs and modals -->
        <modals-container></modals-container>
        <v-dialog></v-dialog>
    </div>
</template>

<script>
    import themeHeader from "./components/layout/default/header.vue";
    import themeFooter from "./components/layout/default/footer.vue";
    import loginPage from "./components/login/login.vue";
    import messageBoxes from "./components/layout/default/messages.vue"
    import auth from "./utils/auth";


    export default {
        name: 'app',
        components: {
            themeHeader,
            themeFooter,
            loginPage,
            messageBoxes
        },
        computed: {
            isLoggedIn: function () {
                return this.$store.getters.isAuthenticated
            }
        },
        created: function(){
            auth.restore()
        }
    }
</script>

<style src="./assets/theme.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue